module.exports = __webpack_public_path__ + "static-portal/img/1.ef33d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.jpg
// module id = Erzt
// module chunks = 4